/*
 *   File : competition.js
 *   Author : https://evoqins.com
 *   Description : Competition card component
 *   Integrations : NA
 *   Version : 1.0.0
*/

//Custom components
import { SecondaryButton, TextButton } from "../Buttons";
import { useNavigate } from "react-router-dom";

// styles
import styles from '../../Style/Component/competition.module.scss';

const CompetitionCard = (props) => {
    const navigate = useNavigate();

    const { data } = props;

    const totalPoints = (data.target ?? []).reduce(
        (sum, item) => sum + Number(item.points || 0),
        0
    );


    return (
        <div className="w-100 d-flex flex-column justify-content-between bg-white e-border-radius-16 e-border-1px-platinum-light overflow-hidden position-relative">
            {data.status &&
                <span className={`${data.status === "Active" ? 'e-bg-philippine-green  e-text-white' : 'e-bg-silvery-white e-text-raisin-black'} position-absolute z-index-2 top-24px left-24px e-border-radius-40 p-1 e-alt-font-noto-sans e-font-10 e-font-weight-400 line-height-10px`}>
                    {data.status}
                </span>
            }
            <div>
                <div className={styles.e_img_wrapper}>
                    <img src={data.image_url}
                        draggable={false}
                        className="object-fit-cover w-100 h-100 overflow-hidden"
                        alt="banner"
                    />
                </div>

                <div className="px-3 pt-3">
                    <div className="row mb-3">
                        <div className="col-xl-9 my-auto">
                            <h6 className={`${props.detail ? 'e-ellipse h-48px' : 'text-truncate'} e-font-18 e-alt-font-noto-sans e-font-weight-500 mb-0 line-height-24px e-text-raisin-black`}>
                                {data.title}
                            </h6>
                        </div>
                        <div className="col-xl-3">
                            <div className="d-flex align-items-center justify-content-end">
                                <h5 className="py-1 px-2  e-border-radius-16 e-bg-spanish-yellow e-font-14 e-alt-font-noto-sans e-font-weight-700 mb-0 line-height-14px e-text-white d-flex align-items-center justify-content-end">
                                    {totalPoints}
                                    <span className="ps-1 e-font-12 e-font-weight-400">
                                        {totalPoints > 0 ? "points" : "point"}
                                    </span>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <p className={`${props.detail ? '' : 'e-ellipse-3-line '} e-font-14 e-alt-font-noto-sans e-font-weight-400 mb-3 line-height-22px e-text-raisin-black`}>
                        {data.description}
                    </p>

                    <div className="d-flex gap-4">
                        <div className="d-block">
                            <p className="e-font-12 e-alt-font-noto-sans e-font-weight-400 mb-0 line-height-22px e-text-raisin-black">
                                Start date
                            </p>
                            <span className="e-font-14 e-alt-font-noto-sans e-font-weight-700 mb-0 line-height-22px e-text-raisin-black letter-spacing-005em ">
                                {data.start_date}
                            </span>
                        </div>
                        <div className="d-block">
                            <p className="e-font-12 e-alt-font-noto-sans e-font-weight-400 mb-0 line-height-22px e-text-raisin-black">
                                End date
                            </p>
                            <span className="e-font-14 e-alt-font-noto-sans e-font-weight-700 mb-0 line-height-22px e-text-raisin-black letter-spacing-005em ">
                                {data.end_date}
                            </span>
                        </div>
                    </div>

                    {props.detail || props.preview ?
                        <div className="pb-2 mb-1">
                            <div className="row pt-4 mb-1">
                                <div className="col-lg-6 col-md-10 col-sm-9 col-12">
                                    <p className="mb-0 e-font-12 e-alt-font-noto-sans e-font-weight-400 mb-0 line-height-18px e-text-raisin-black">
                                        Target product
                                    </p>
                                </div>
                                <div className="col-lg-2 col-md-2 col-sm-3 col-12 px-0">
                                    <p className="mb-0 e-font-12 e-alt-font-noto-sans e-font-weight-400 mb-0 line-height-18px e-text-raisin-black">
                                        Sales target
                                    </p>
                                </div>

                                {/* <div className="col-lg-3 col-md-2 col-sm-3 col-12 pe-0">
                                    <p className="mb-0 e-font-12 e-alt-font-noto-sans e-font-weight-400 mb-0 line-height-18px e-text-raisin-black">
                                        Points allocated
                                    </p>
                                </div> */}
                            </div>

                            {data.target?.map((target, key) => (
                                <div className="row mb-1" key={key}>
                                    <div className="col-lg-6 col-md-10 col-sm-9 col-12">
                                        <p className="mb-0 e-font-14 e-alt-font-noto-sans e-font-weight-700 line-height-18px e-text-raisin-black letter-spacing-005em">
                                            {target.target_product}
                                        </p>
                                    </div>

                                    <div className="col-lg-2 col-md-2 col-sm-3 col-12 px-0">
                                        <p className="mb-0 e-font-14 e-alt-font-noto-sans e-font-weight-700 line-height-18px e-text-raisin-black letter-spacing-005em">
                                            {target.sales_target}
                                        </p>
                                    </div>

                                    {/* <div className="col-lg-3 col-md-2 col-sm-3 col-12 pe-0">
                                        <p className="mb-0 e-font-14 e-alt-font-noto-sans e-font-weight-700 line-height-18px e-text-raisin-black letter-spacing-005em">
                                            {target.points}
                                        </p>
                                    </div> */}
                                </div>
                            ))}
                        </div>
                        :
                        <div className="row pt-4 mb-3">
                            <div className="col-lg-7 col-md-10 col-sm-9 col-12">
                                <p className="e-font-12 e-alt-font-noto-sans e-font-weight-400 mb-0 line-height-18px e-text-raisin-black">
                                    Target product
                                </p>
                                <p className="mb-0 e-font-14 e-alt-font-noto-sans e-font-weight-700 mb-0 line-height-18px e-text-raisin-black letter-spacing-005em  ">
                                    {props.data.target[0]?.target_product}
                                </p>
                            </div>
                            <div className="col-lg-2 col-md-2 col-sm-3 col-12 px-0">
                                <p className="mb-1 e-font-12 e-alt-font-noto-sans e-font-weight-400 mb-0 line-height-18px e-text-raisin-black">
                                    Sales target
                                </p>
                                <p className="mb-0 e-font-14 e-alt-font-noto-sans e-font-weight-700 mb-0 line-height-18px e-text-raisin-black letter-spacing-005em ">
                                    {props.data.target[0]?.sales_target}
                                </p>
                            </div>

                            <div className="col-lg-3 col-md-2 col-sm-3 col-12 pe-0">
                                <p className="mb-1 e-font-12 e-alt-font-noto-sans e-font-weight-400 mb-0 line-height-18px e-text-raisin-black">
                                    Points allocated
                                </p>
                                <p className="mb-0 e-font-14 e-alt-font-noto-sans e-font-weight-700 mb-0 line-height-18px e-text-raisin-black letter-spacing-005em ">
                                    {props.data.target[0]?.points}
                                </p>
                            </div>

                            {data.target.length > 1 &&
                                <TextButton name="View more"
                                    className="w-max-content"
                                    onPress={props.handleNavigate} />
                            }
                        </div>
                    }

                    {(props.detail || props.preview) && data.specific_target &&
                        <div className="mb-3">
                            <p className="mb-1 e-font-14 e-alt-font-noto-sans e-font-weight-400 mb-0 line-height-22px e-text-raisin-black">
                                Applicable {data.audience_type_id === 1 ? "users:" : data.audience_type_id === 2 ? "areas:" : data.audience_type_id === 3 ? "shops:" : ""}
                            </p>

                            <ul className="ps-3 d-flex flex-column gap-1">
                                {data.target_user?.length > 0 ? data.target_user?.map((item, key) => (
                                    <li key={key} className="e-text-raisin-black e-font-14 e-alt-font-noto-sans e-font-weight-400 line-height-22px">
                                        {item.label || item.name}
                                    </li>
                                )) : '-'}
                            </ul>
                        </div>
                    }

                    <span className="e-font-14 e-alt-font-noto-sans e-font-weight-400 mb-0 line-height-22px e-text-raisin-black">
                        <img src={require("../../Assets/Image/CountryAdmin/ManageCompetition/judge.svg").default}
                            alt="judge"
                            draggable={false}
                            className="me-1" />
                        Rules
                    </span>
                    {props.detail || props.preview ?
                        <ol className='ps-3 mt-1 e-font-14 e-alt-font-noto-sans e-font-weight-400 mb-0 line-height-22px e-text-raisin-black'>
                            {
                                data.rules?.map((item, key) => (
                                    <li key={key} className="mb-2 ms-1">{item}</li>
                                ))
                            }
                        </ol>
                        :
                        <div className="d-flex flex-column justify-content-between">
                            <div className="d-flex align-items-start">
                                <p className="mb-0 e-font-14 e-alt-font-noto-sans e-font-weight-400 mb-0 line-height-22px e-text-raisin-black">1.</p>
                                <p className='ps-1 mb-1 e-font-14 e-alt-font-noto-sans e-font-weight-400 mb-0 line-height-22px e-text-raisin-black e-ellipse'>
                                    {data.rules[0]}
                                </p>
                            </div>
                            {data.rules?.length > 1 &&
                                <TextButton name="View more"
                                    className="w-max-content"
                                    onPress={props.handleNavigate} />
                            }
                        </div>
                    }
                </div>
            </div>

            <div className="px-3 pb-3 mt-2">
                {props.detail ?
                    <div className='d-flex justify-content-end mt-2 ms-auto'>
                        <TextButton name="Edit"
                            className="p-2"
                            onPress={props.handleEdit} />
                        <TextButton name="Delete"
                            className="p-2 e-text-lust"
                            onPress={props.handleConfirm} />
                    </div>
                    :
                    !props.preview ?
                        <div className="d-flex gap-3 flex-wrap justify-content-between align-items-center">
                            <h6 className="e-font-14 e-alt-font-noto-sans e-font-weight-600 mb-0 line-height-22px e-text-raisin-black e-letter-spacing-005em">
                                Total agents completed: {data.completed_agent_count}
                            </h6>
                            <div>
                                <div className="d-flex justify-content-end align-items-center gap-12px">

                                    <TextButton name="View details"
                                        onPress={() => {
                                            navigate("detail", {
                                                state: {
                                                    tab_index: props.tabIndex,
                                                    id: data.competition_id
                                                }
                                            })
                                        }} />

                                    {/* <SecondaryButton name="Send notification"
                                    status={props.loader}
                                    className={`${props.loader ? 'padding-6px-tb' : 'py-2'}  text-nowrap me-2 e-border-radius-16 mt-xl-0 mt-lg-0 mt-md-0 mt-sm-0 mt-2 w-148px`}
                                    onPress={props.sendNotification} /> */}
                                    <SecondaryButton name="Overview"
                                        className="text-nowrap e-border-radius-16"
                                        onPress={props.handleNavigate} />
                                </div>
                            </div>
                        </div>
                        :
                        null
                }
            </div>
        </div >
    )
}

CompetitionCard.defaultProps = {
    handleNavigate: () => { }
}
export default CompetitionCard